import React from 'react';

const MEDIA_ANCHO = '(min-width: 640px)';

// ¿Hay ancho para la rejilla (sm de Tailwind)? En el celular se pintan tarjetas (regla de UX 11).
// Sin matchMedia (jsdom, navegadores viejos) se pinta la rejilla.
export function useAncho() {
  const sinMedia = typeof window === 'undefined' || typeof window.matchMedia !== 'function';
  const [ancho, setAncho] = React.useState(() => (sinMedia ? true : window.matchMedia(MEDIA_ANCHO).matches));
  React.useEffect(() => {
    if (sinMedia) return undefined;
    const mq = window.matchMedia(MEDIA_ANCHO);
    const cambia = (e) => setAncho(e.matches);
    setAncho(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', cambia);
    else if (mq.addListener) mq.addListener(cambia);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', cambia);
      else if (mq.removeListener) mq.removeListener(cambia);
    };
  }, [sinMedia]);
  return ancho;
}
